/**
 * Copyright (c), Vector Engineering LLC
 * All rights reserved.
 * 
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 * Commercial use requires explicit written permission.
 */

/**
 * This script patches any analytics that may be causing errors
 * when blocked by ad blockers or privacy tools.
 */

// Execute when the window loads
window.addEventListener('load', () => {
  // Detect and patch PostHog errors
  const patchPostHog = () => {
    if (window.posthog) {
      // Create a wrapper for posthog that catches errors
      const originalPostHog = window.posthog;
      
      // Replace posthog with a version that catches errors
      window.posthog = new Proxy(originalPostHog, {
        get(target, prop) {
          const original = target[prop];
          
          // If it's a function, wrap it to catch errors
          if (typeof original === 'function') {
            return function(...args) {
              try {
                return original.apply(target, args);
              } catch (err) {
                console.debug('PostHog error suppressed:', err);
                return null;
              }
            };
          }
          
          return original;
        }
      });
      
      console.debug('PostHog patched to handle blocking gracefully');
    }
  };
  
  // Give analytics a chance to load first
  setTimeout(patchPostHog, 1000);
});
